import type { SvgIconComponent } from '@mui/icons-material';

export const isColumnSortable = <P>(headerId: string, unableSortFor: 'none' | 'all' | (keyof P)[]): boolean => {
  switch (unableSortFor) {
    case 'none':
      return true;
    case 'all':
      return false;
    default:
      return !unableSortFor.includes(headerId as keyof P);
  }
};

export type SortDirection = 'asc' | 'desc';

export type SortState<P> = {
  column: keyof P | '';
  direction: SortDirection;
};

export const getSortHandler = <P>(
  headerId: string,
  currentSort: SortState<P> | undefined,
  onSort: ((sort: SortState<P>) => void) | undefined,
  isActionsColumn: boolean
) => {
  return () => {
    if (isActionsColumn) return;

    if (!onSort) return;

    if (currentSort?.column === headerId && currentSort.direction === 'desc') {
      onSort({ column: '', direction: 'asc' });
      return;
    }

    onSort({
      column: headerId as keyof P,
      direction: currentSort?.column === headerId && currentSort.direction === 'asc' ? 'desc' : 'asc',
    });
  };
};

export type TableControls = {
  [p: string]: {
    visible: boolean;
    disabled?: boolean;
    onClick: () => void;
    icon: SvgIconComponent;
    label: string;
    id: string;
  };
};

export const getTableControlsValues = (tableControls: TableControls = {}) => {
  return Object.entries(tableControls)

    .filter(([_, value]) => value.visible)
    .map(([key, value]) => ({
      icon: value.icon,
      onClick: value.onClick,
      label: value.label,
      id: key,
      disabled: value.disabled,
    }));
};
